import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EntitytypeService } from './entitytype.service';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { EntitytypemodalComponent } from '../../directives/entitytypemodal/entitytypemodal.component';
import { Companytype, GlobalMessage } from '../../utility/modals';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-entitytype',
  templateUrl: './entitytype.component.html',
  styleUrls: ['./entitytype.component.css']
})
export class EntitytypeComponent implements OnInit {
  @ViewChild('dt') dt: any;
  tableData: any[] = [];
  selectedItem: MenuItem | null = null;
  commonScrollHeight = '';
  searchText: string;
  ref: DynamicDialogRef | undefined;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  options = [];
  count: number = 0;
  tablecount: number = 0;
  paginatorArray = []
  visible: boolean = false;
  excel_paragraph = '';
  public sortfield = 'companytype';
  templatedownloadtext = '';
  rowsize: number = 10;
  exceldownloadModal = false;
  currentPageIndex: number = 0;
  downloadformate = false;
  position = 'top';
  cols = [];
  message: GlobalMessage = new GlobalMessage()
  _selectedColumns = [];
  entitytypelistarray: Array<Companytype> = [];
  constructor(public router: Router,private spinner:NgxSpinnerService, public dialogService: DialogService, public PagehelpmodalService: PagehelpmodalService,
    private entitytypeservice: EntitytypeService, public utilityservice: Utilityservice) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight()
    this.getentitytypeList();
    this.dynamiccols();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }
  dynamiccols() {
    this.cols = [
      { field: "id", header: "ID", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'headerid' },
      { field: "companytype", header: "Entity Type", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'headerid' },
      { field: "createdby", header: "Created By", type: 'Date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdon", header: "Created On", type: 'Date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' }
    ]
    this._selectedColumns = this.cols;
  }

  getentitytypeList() {
    //this.spinner.show();
    const currentPageSize = this.rowsize;

    this.entitytypeservice.getall_entitytype().subscribe({
      next: (data: any) => {
        //this.spinner.hide();
        this.tableData = data;
        this.entitytypelistarray = data.map((item: any) => ({ ...item, isSelect: false }));

        this.options = this.utilityservice.getOptionDropdown(data.length);
        this.paginatorArray = this.options.map((e) => e.value);

        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }

        this.rowsize = currentPageSize;
        this.totalRecords = this.entitytypelistarray.length;
        this.tablecount = data.count ?? data.length;

        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
          }
        }, 0);
      },
      error: (error) => {
        //this.spinner.hide();
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error?.error || "Error",
          text: `This error occurred at: ${timestamp}`,
          icon: "error",
        });
      },
    });
  }

  show(title, data) {
    let details = {}
    if (title === 'Modify Entity Type') {
      this.entitytypeservice.getEntitytypeDataView_byId(data.id).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(EntitytypemodalComponent, {
          header: title,
          width: '50vw',
          height: '30%',
          data: { title: title, datas: details },
          contentStyle: {},
          baseZIndex: 10000,
          // maximizable: true,
        });
        this.ref.onClose.subscribe(() => {
          this.getentitytypeList();
        });
      })
    } else {
      details = {}
      this.ref = this.dialogService.open(EntitytypemodalComponent, {
        header: title,
        width: '50vw',
        height: '30%',
        data: { title: title, datas: details },
        contentStyle: { overflow: '' },
        baseZIndex: 10000,
        // maximizable: true,
      });
      this.ref.onClose.subscribe(() => {
        this.getentitytypeList();
      });
    }
  }
  downloadgridexcel() {
    this.spinner.show();
    this.entitytypeservice.entitytypeDataExcel().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Entitytype_Master_Data.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
      this.spinner.hide();
      Swal.fire('File downloaded successfully!', '', 'success');
    }, error => {
      this.spinner.hide();
      Swal.fire('Something went wrong', '', 'error');
    });
  }

  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }

}



